<template>
  <div class="subs">
    <div class="section container">
      <Block class="hero" pre-text-class="circle" text="sub_description">
        <template #header>
          <h2 class="title header-h1">
            {{ $t("sub_title") }}
            <br v-if="$i18n.locale == 'es' || $i18n.locale == 'po'" />
            <span class="brand"> {{ $t("Successful") }} </span>
            {{ $t("betting") }}
          </h2>
        </template>
        <Hero :is-new="user ? user.isNewUser : true" />
      </Block>
      <Block
        title="pre_view_title"
        text="pre_view_text"
        pre-text="Start_with_us"
      >
        <PreView />
      </Block>
      <Block>
        <Info />
      </Block>
      <Block id="sub_id" title="sub_title1" text="sub_text1" pre-text="Tariffs">
        <!-- ждём API только здесь: остальная страница статична и рисуется сразу,
             иначе до ответа /score/sub не видно вообще ничего -->
        <div v-if="isListLoading" class="cards-loader">
          <span class="cards-loader__spinner"></span>
        </div>
        <div v-else class="cards">
          <Sub
            v-for="sub in subscriptions || []"
            :key="sub._id"
            v-bind="sub"
            :sub-key="sub.key"
            :sub-try-free="sub.tryFree"
            :user-subscriptions="user ? user.subscriptions : null"
            :email-verified="user ? user.email_verified : false"
            :is-loading="isBuyLoading"
            :disabled="disabled === false"
            :is-new="user ? user.isNewUser : true"
            :is-now-payment-work="isNowPaymentWork"
            @buy="onBuy"
            @buy-coingate="onBuyCoingate"
            @buy-nowpayment="onBuyNowpayment"
          />
        </div>
      </Block>
      <Block>
        <Process />
      </Block>
      <!-- <Block title="Real user experiences" text="See what people who win regularly with our data say" preText="Reviews">
        <Reviews />
      </Block> -->
      <Block title="faq_title" text="faq_text" pre-text="FAQ">
        <Block>
          <Faq />
        </Block>
      </Block>
      <!-- Start winning with us -->
      <!-- <div class="column is-full" id="agreement-check" v-if="hasAvailableSubscriptions">
        <div class="field">
          <label class="checkbox">
            <input type="checkbox" v-model="disabled" />
            <div class="check">{{ disabled ? "✓" : "" }}</div>
            <span v-html="$t('subscribe_agreement')"></span>
          </label>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Sub from "../components/subscribe/Sub.vue";
import Block from "../components/common/Block.vue";
import Hero from "../components/subscribe/Hero.vue";
import PreView from "../components/subscribe/PreView.vue";
import Info from "../components/subscribe/Info.vue";
import Process from "../components/subscribe/Process.vue";
import Faq from "../components/subscribe/Faq.vue";

// import AOS from 'aos';

export default {
  name: "Subs",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { Sub, Block, Hero, PreView, Info, Process, Faq },
  data: () => ({
    disabled: false,
    isBuyLoading: false,
    isListLoading: false,
    isNowPaymentWork: false,
  }),
  // mounted() {
  //   setTimeout(() => {
  //     AOS.refresh();
  //   }, 5000);
  //   AOS.init();
  // },
  // updated() {
  //   AOS.refresh();
  // },
  computed: {
    columnCount() {
      const c = this.subscriptions.length;
      if (c >= 3) return 3;
      return !c ? 1 : c;
    },
    subscriptions() {
      const raw = this.$store.state.subscription.list;
      if (!raw) return null; // не загружено — created() выполнит фетч

      const paid = raw
        .filter((s) => !s.isSystem)
        .slice()
        .sort((a, b) => a.price - b.price);

      // если у юзера есть активная подписка — системные статусы не показываем
      const hasActiveSub = Boolean(
        this.user && this.user.subscriptions && this.user.subscriptions.length,
      );
      if (hasActiveSub) return paid;

      // одна системная карточка первой: гость → guest, авторизован → user
      const wantKey = this.user ? "user" : "guest";
      const system = raw.find((s) => s.isSystem && s.systemKey === wantKey);
      return system ? [system, ...paid] : paid;
    },
    user() {
      return this.$store.state.user;
    },
    hasAvailableSubscriptions() {
      const userSubscriptionIds = this.user
        ? this.user.subscriptions.map(({ subscription }) => subscription)
        : [];
      const availableSubscriptions = this.subscriptions.filter(
        ({ _id }) => !userSubscriptionIds.includes(_id),
      );
      return availableSubscriptions.length > 0;
    },
  },
  watch: {
    isListLoading: function (newValue) {
      if (newValue === false) {
        const hash = window.location.hash;
        if (hash) {
          this.$router.push({ hash });
        }
      }
    },
    user: function (newValue, oldValue) {
      if (!oldValue && newValue) {
        this.checkNowpayment();
      }
    },
  },
  created() {
    if (this.subscriptions) return;
    this.isListLoading = true;

    this.$store
      .dispatch("getSubscription")
      .catch((text) => {
        this.$notify({
          type: "error",
          title: `❌ ${this.$t("Error")}`,
          text,
        });
      })
      .finally(() => {
        this.isListLoading = false;
      });
  },
  mounted() {
    const query = new URLSearchParams(window.location.search);
    const isSubscriptionSuccess = query.get("subscription_success");
    const isSubscriptionCanceled = query.get("subscription_canceled");
    const isFromPortal = query.get("from_portal");

    if (isSubscriptionSuccess || isSubscriptionCanceled || isFromPortal) {
      this.$router.replace("/subscriptions");
      this.isListLoading = true;
      this.$store
        .dispatch("session")
        .catch((text) => {
          this.$notify({
            type: "error",
            title: `❌ ${this.$t("Error")}`,
            text,
          });
        })
        .finally(() => {
          if (isSubscriptionSuccess) {
            this.$notify({
              type: "success",
              title: `🎉 ${this.$t("Success")}`,
              text: this.$t("subscription_success"),
            });
          }
          if (isSubscriptionCanceled) {
            this.$notify({
              type: "success",
              title: `🎉 ${this.$t("Success")}`,
              text: this.$t("subscription_canceled"),
            });
          }
          this.isListLoading = false;
        });
    }

    if (this.isListLoading === false) {
      const hash = window.location.hash;
      if (hash) {
        this.$router.push({ hash });
      }
    }
    this.checkNowpayment();
  },
  methods: {
    checkNowpayment() {
      if (!this.user) return;

      this.isBuyLoading = true;
      this.$store
        .dispatch("checkNowpayment")
        .then((res) => {
          if (res) {
            this.isNowPaymentWork = true;
          }
        })
        .catch(() => {
          console.log("Nowpayment not work");
        })
        .finally(() => {
          this.isBuyLoading = false;
        });
    },
    onBuyNowpayment(id) {
      if (this.isBuyLoading || this.checkAuth()) return;

      this.isBuyLoading = true;
      this.$store
        .dispatch("buyNowpaymentSub", id)
        .then((url) => {
          console.log(url);
          window.location.href = url;
        })
        .catch((text) => {
          this.$notify({
            type: "error",
            title: `❌ ${this.$t("Error")}`,
            text,
          });
        })
        .finally(() => {
          this.checkSub();
          this.isBuyLoading = false;
        });
    },
    onBuyCoingate(id) {
      if (this.isBuyLoading || this.checkAuth()) return;

      this.isBuyLoading = true;
      this.$store
        .dispatch("buyCoingateSub", id)
        .then((url) => {
          console.log(url);
          window.location.href = url;
        })
        .catch((text) => {
          this.$notify({
            type: "error",
            title: `❌ ${this.$t("Error")}`,
            text,
          });
        })
        .finally(() => {
          this.checkSub();
          this.isBuyLoading = false;
        });
    },
    onBuy(_id) {
      if (this.isBuyLoading || this.checkAuth()) return;

      this.isBuyLoading = true;
      this.$store
        .dispatch("buySub", _id)
        .then((url) => {
          window.location.href = url;
        })
        .catch((text) => {
          if (text.message === "Request failed with status code 403") {
            this.$notify({
              type: "info",
              title: ` ${this.$t("Info")}`,
              text: `${this.$t("subs.messages.already_use")}`,
            });
            return;
          }

          this.$notify({
            type: "error",
            title: `❌ ${this.$t("Error")}`,
            text,
          });
        })
        .finally(() => {
          this.checkSub();
          this.isBuyLoading = false;
        });
    },
    checkAuth() {
      if (!this.$store.getters.isAuth) {
        this.$notify({
          type: "error",
          title: `❌ ${this.$t("Error")}`,
          text: "You must be logged in to purchase",
        });
        return true;
      }
    },
    // после попытки покупки перечитываем сессию юзера (подписки + права)
    checkSub() {
      return this.$store.dispatch("session").catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../scss/variables" as *;
.subs {
  margin: 10px auto 50px;
}

// класс .loader из старой разметки нигде не описан (bulma не подключена),
// поэтому спиннер свой
.cards-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 320px; // примерно высота ряда карточек — блок не схлопывается
  padding: 35px 0 0;
}

.cards-loader__spinner {
  width: 48px;
  height: 48px;
  border: 3px solid var(--font-color);
  border-top-color: var(--brand-color);
  border-radius: 50%;
  animation: cards-spin 0.8s linear infinite;
}

@keyframes cards-spin {
  to {
    transform: rotate(360deg);
  }
}

.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
  align-items: stretch;
  gap: 26px;
  padding: 35px 0 0;
  width: 100%;
}

.block.hero {
  padding: 0;
}

.brand {
  color: var(--brand-color);
}

@media screen and (max-width: $mini-mob) {
  .section.container {
    padding: 0;
  }
}

.title {
  padding: 0 0 41px;
  line-height: 1.2;
  font-weight: 600;
  text-align: center;
  letter-spacing: -0.02em;
  color: var(--back-color);
  font-size: 55px;
  margin: 0;
}
.header-h1 {
  font-size: 64px;
}

@media (max-width: $fullhd) {
  .title {
    font-size: 40px;
  }

  .header-h1 {
    font-size: 64px;
  }
}

@media screen and (max-width: $mobile) {
  .title {
    font-size: 28px;
    padding-bottom: 20px;
  }

  .header-h1 {
    font-size: 32px;
  }
}
</style>
